import styled from '@emotion/styled';
import _ from 'lodash';

import placeholder_url from '../../placeholder';
import RichText from './PageBuilder/RichText';
import Heading from './PageBuilder/Heading';
import Picture from './oc-picture';


const heights = {
  tall: 680,
  medium: 464,
  short: 240,
};

const HeroImage = styled.div`
  background: url('${props => props.imageUrl}');
  background-size: cover;
  background-position: center;
  height: ${heights.short}px;
  margin-bottom: 32px;

  @media (min-width: 768px) {
    height: ${props => heights[props.height ?? 'short']}px;
  }

  @media (min-width: 1200px) {
    height: ${props => heights[props.height ?? 'short']}px;
  }
`;

const HeroTextContainer = styled.div`
  padding: 0 15px;
  @media (min-width: 1200px) {
    padding: 0 85px;
  }
`;

const HeroType6 = ({ copy, image, height }) => {
  const imageUrl = image && Picture.DefaultOrCrop(image.file, image.crop, placeholder_url(1360, heights[height ?? 'short']));
  return <>
    <HeroImage imageUrl={imageUrl} height={height} aria-label={image?.alt}/>
    <HeroTextContainer>
      <Heading mainHeading={copy.mainHeading}/>
      <RichText content={copy.body} />
    </HeroTextContainer>
  </>
};

export default HeroType6;
